(function () {
    document.addEventListener("DOMContentLoaded", function () {
        SetPaddingLeft();
    })

    window.addEventListener("resize", function () {
        SetPaddingLeft();
    })

    function SetPaddingLeft() {
        // spacing
        let value = document.querySelector('.page-subnavigation__item').offsetLeft;
        // space slider elements
        let professionalsWrapper = document.querySelector(".professional-slider-card__wrapper");
        if (professionalsWrapper !== null) {
            professionalsWrapper.style.paddingLeft = value + "px";
            professionalsWrapper.style.paddingRight = value + "px";
        }
        let awardWrapper = document.querySelector(".award-card__wrapper");
        if (awardWrapper !== null) {
            awardWrapper.style.paddingLeft = value + "px";
            awardWrapper.style.paddingRight = value + "px";
        }

    }
})();